<template>
  <div class="step-content">
    <div class="section">
      <cr-highlighted-title :title="'PGA - IBS Data'" />

      <cr-label :title="'Created by'" :required="true" />
      <cr-select
        :options="createdByOptions"
        :id="'input.m_step_3.m_jc_sc_80'"
        title="m_jc_sc_80"
        @focus="this.$emit('showRestrictions', 'm_step_3.m_jc_sc_80')"
        @blur="this.$emit('validateInput', 'm_step_3.m_jc_sc_80')"
        v-model="form.m_step_3.m_jc_sc_80"
      />

      <cr-info
        :type="'error'"
        :id="'error.m_step_3.m_jc_sc_80'"
        :text="'Field cannot be empty'"
      />
    </div>

    <div class="section">
      <cr-highlighted-title :title="'Customer Data'" />
      <cr-label :title="'Company Name'" :required="true" />
      <cr-input
        :id="'input.m_step_3.m_jc_sc_81'"
        title="m_jc_sc_81"
        @focus="this.$emit('showRestrictions', 'm_step_3.m_jc_sc_81')"
        @blur="this.$emit('validateInput', 'm_step_3.m_jc_sc_81')"
        v-model="form.m_step_3.m_jc_sc_81"
      />

      <cr-info
        :type="'error'"
        :id="'error.m_step_3.m_jc_sc_81'"
        :text="'Input cannot be empty'"
      />

      <cr-label :title="'Location'" />
      <cr-textarea
        :id="'input.m_step_3.m_jc_sc_82'"
        title="m_jc_sc_82"
        v-model="form.m_step_3.m_jc_sc_82"
      />

      <!--      <cr-info :type="'error'"-->
      <!--               :id="'error.m_step_3.m_jc_sc_82'"-->
      <!--               :text="'Input cannot be empty'"/>-->

      <cr-label :title="'Created for'" />
      <cr-input
        :id="'input.m_step_3.m_jc_sc_83'"
        title="m_jc_sc_83"
        v-model="form.m_step_3.m_jc_sc_83"
      />

      <!--      <cr-info :type="'error'"-->
      <!--               :id="'error.m_step_3.m_jc_sc_83'"-->
      <!--               :text="'Input cannot be empty'"/>-->

      <cr-label :title="'Email'" />
      <cr-input
        :id="'input.m_step_3.m_jc_sc_84'"
        title="m_jc_sc_84"
        v-model="form.m_step_3.m_jc_sc_84"
      />

      <!--      <cr-info :type="'error'"-->
      <!--               :id="'error.m_step_3.m_jc_sc_84'"-->
      <!--               :text="'Input cannot be empty'"/>-->

      <cr-label :title="'Mobile phone'" />
      <cr-input
        :id="'input.m_step_3.m_jc_sc_85'"
        title="m_jc_sc_85"
        v-model="form.m_step_3.m_jc_sc_85"
      />

      <!--      <cr-info :type="'error'"-->
      <!--               :id="'error.m_step_3.m_jc_sc_85'"-->
      <!--               :text="'Input cannot be empty'"/>-->

      <cr-label :title="'Date'" />
      <cr-input
        :type="'date'"
        title="m_step_3.date"
        v-model="form.m_step_3.date"
      />
    </div>

    <div class="section">
      <cr-highlighted-title :title="'Plant Data'" />

      <cr-label :title="'Plant / Project Title'" />
      <cr-textarea
        :id="'input.m_step_3.m_jc_sc_86'"
        title="m_jc_sc_86"
        v-model="form.m_step_3.m_jc_sc_86"
      />

      <!--      <cr-info :type="'error'"-->
      <!--               :id="'error.m_step_3.m_jc_sc_86'"-->
      <!--               :text="'Input cannot be empty'"/>-->

      <cr-label :title="'Site of Installation'" />
      <cr-input
        :id="'input.m_step_3.m_jc_sc_87'"
        title="m_jc_sc_87"
        v-model="form.m_step_3.m_jc_sc_87"
      />

      <!--      <cr-info :type="'error'"-->
      <!--               :id="'error.m_step_3.m_jc_sc_87'"-->
      <!--               :text="'Input cannot be empty'"/>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
.step-content {
  background: #ffffff;
  border: 1px solid #efefef;
  padding: 20px 20px 100px;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.04);

  .section:not(:last-child) {
    border-bottom: 1px solid #cfd8dc;
    padding-bottom: 20px;
    margin-bottom: 30px;
  }
}
</style>

<script>
import CrHighlightedTitle from "@/components/CrHighlightedTitle";
import CrInput from "@/components/CrInput";
import CrTextarea from "@/components/CrTextarea";
import CrSelect from "@/components/CrSelect";
import CrLabel from "@/components/CrLabel";
import CrInfo from "@/components/CrInfo";

export default {
  components: {
    CrHighlightedTitle,
    CrInput,
    CrTextarea,
    CrSelect,
    CrLabel,
    CrInfo,
  },
  props: {
    form: {
      type: Object,
      required: false,
      default: null,
    },
    config: {
      type: Object,
      required: false,
      default: null,
    },
    user_data: {
      type: Object,
      required: false,
      default: null,
    },
    formComputed: {},
  },

  emits: ["showRestrictions", "validateInput"],

  data() {
    return {};
  },

  computed: {
    createdByOptions() {
      const createdByJson = this.user_data.created_by;
      let result = {};

      Object.keys(createdByJson).map(
        (key) => (result[key] = createdByJson[key]["name"])
      );

      return result;
    },
  },

  methods: {},
};
</script>
